module.exports = __webpack_public_path__ + "static/media/boombox.93fd06d7.svg";